export const HOME_LAB_CHAPTERS = 5;

export function clampUnit(value: number): number {
  return Number.isFinite(value) ? Math.min(1, Math.max(0, value)) : 0;
}

export function getHomeLabState(offset: number, travel: number) {
  const raw = travel > 0 ? clampUnit(offset / travel) * (HOME_LAB_CHAPTERS - 1) : 0;
  // scrollTo округляет координату до пикселя: якорь не должен оставаться незавершённым.
  const position = Math.abs(offset - getChapterOffset(Math.round(raw), travel)) <= .75 ? Math.round(raw) : raw;
  const progress = position / (HOME_LAB_CHAPTERS - 1);
  const fromChapter = Math.floor(position);
  const toChapter = Math.min(HOME_LAB_CHAPTERS - 1, Math.ceil(position));
  const chapter = Math.round(position);
  return {
    chapter,
    progress,
    fromChapter,
    toChapter,
    transitionProgress: fromChapter === toChapter ? 1 : position - fromChapter,
  };
}

export function getChapterOffset(chapter: number, travel: number): number {
  const index = Number.isFinite(chapter) ? Math.max(0, Math.min(HOME_LAB_CHAPTERS - 1, Math.round(chapter))) : 0;
  return Math.max(0, travel) * index / (HOME_LAB_CHAPTERS - 1);
}
